import { Box, Card, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

// YouTube linklarni shu yerga qo'ying (watch URL yoki youtu.be ham bo'ladi).
// Bo'sh qoldirilsa, faqat title ko'rinadi.
const VIDEO_ITEMS = [
  {
    titleKey: 'landing.videos.item1.title',
    url: 'https://youtu.be/y9fKQgbE6jk?si=LkyETzc-vOGbm_ma'
  },
  {
    titleKey: 'landing.videos.item2.title',
    url: 'https://youtu.be/mgk0laVKD4M?si=jHUh68kblMTN0AoQ'
  },
  {
    titleKey: 'landing.videos.item3.title',
    url: 'https://youtu.be/pYyo1jXzHoM'
  }
];

const toEmbedUrl = (url) => {
  if (!url || !String(url).trim()) return '';
  const value = String(url).trim();

  try {
    const parsed = new URL(value);
    if (parsed.hostname.includes('youtu.be')) {
      const id = parsed.pathname.replace('/', '');
      return id ? `https://www.youtube.com/embed/${id}` : '';
    }
    if (parsed.hostname.includes('youtube.com')) {
      const id = parsed.searchParams.get('v');
      if (id) return `https://www.youtube.com/embed/${id}`;
      const parts = parsed.pathname.split('/');
      const embedIdx = parts.indexOf('embed');
      if (embedIdx >= 0 && parts[embedIdx + 1]) {
        return `https://www.youtube.com/embed/${parts[embedIdx + 1]}`;
      }
    }
  } catch (e) {
    return '';
  }

  return '';
};

export default function LandingVideoLessonsSection() {
  const { t } = useTranslation();

  return (
    <Box id="video-lessons" sx={{ scrollMarginTop: 96, mb: 6 }}>
      <Typography variant="h4" fontWeight={800} sx={{ mb: 3 }}>
        {t('landing.videos.title')}
      </Typography>

      <Grid container spacing={3}>
        {VIDEO_ITEMS.map((item) => {
          const title = t(item.titleKey);
          const embedUrl = toEmbedUrl(item.url);

          return (
            <Grid item xs={12} md={6} key={item.titleKey}>
              <Card sx={{ p: 2, borderRadius: 3, height: '100%' }}>
                <Typography variant="h6" fontWeight={700} sx={{ mb: 1.5 }}>
                  {title}
                </Typography>
                {embedUrl ? (
                  <Box
                    sx={{
                      position: 'relative',
                      width: '100%',
                      pt: '56.25%',
                      borderRadius: 2,
                      overflow: 'hidden',
                      bgcolor: 'grey.100'
                    }}>
                    <Box
                      component="iframe"
                      src={embedUrl}
                      title={title}
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      allowFullScreen
                      sx={{
                        position: 'absolute',
                        inset: 0,
                        border: 0,
                        width: '100%',
                        height: '100%'
                      }}
                    />
                  </Box>
                ) : (
                  <Box
                    sx={{
                      width: '100%',
                      pt: '56.25%',
                      borderRadius: 2,
                      bgcolor: 'grey.100',
                      border: '1px dashed',
                      borderColor: 'divider',
                      position: 'relative'
                    }}>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{
                        position: 'absolute',
                        inset: 0,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        px: 2,
                        textAlign: 'center'
                      }}>
                      YouTube link qo‘shilmagan
                    </Typography>
                  </Box>
                )}
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
}
